import { Button, Paragraph, Show, tokens } from '@welbe/web-design-system';
import { ReactComponent as OpenFile } from '../../../../App/assets/img/openFile.svg';
import { useState } from 'react';
import { FiTrash } from 'react-icons/fi';
import {
	extensionToCategory,
	thumbCategoryIcons,
	units,
} from './Preview.contants';
import { ButtonsContainer, Content, Item } from './Preview.styles';
import { PreviewProps } from './Preview.types';
import { FilePreview } from './components/FilePreview/FilePreview';

export const Preview = ({
	files,
	onChangeFiles,
	onRemoveFile,
	enableOpenFileButton = false,
}: PreviewProps) => {
	const [selectedFile, setSelectedFile] = useState<File>();

	const formatFileSize = (sizeInBytes: number): string => {
		if (sizeInBytes === 0) return '0 Bytes';

		const index = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
		const formattedSize = (sizeInBytes / Math.pow(1024, index)).toFixed(2);

		return `${formattedSize} ${units[index]}`;
	};

	const renderThumbIcon = (fileType: string) => {
		const category = extensionToCategory[fileType];
		const Icon = category
			? thumbCategoryIcons[category]
			: thumbCategoryIcons['default'];

		return <Icon size={30} color={tokens.color_gray_dark} />;
	};

	const handleDeleteFile = (fileName: string) => {
		const updatedFiles = files.filter((file: File) => file.name !== fileName);
		const deletedFile = files.find((file: File) => file.name === fileName);

		if (deletedFile && onRemoveFile) {
			onRemoveFile(deletedFile);
		}

		onChangeFiles(updatedFiles);
	};

	if (selectedFile) {
		return (
			<FilePreview
				file={selectedFile}
				isVisible={true}
				onClose={() => setSelectedFile(undefined)}
			/>
		);
	}

	if (files?.length > 0) {
		return (
			<Item>
				{files.map((file: File) => (
					<Content key={file.name}>
						<div>
							{renderThumbIcon(file.type)}
							<div>
								<Paragraph
									title={file.name}
									fontWeight="600"
									color={tokens.color_gray_dark}
									elipsis
									width="215px"
								>
									{file.name}
								</Paragraph>
								<Show when={file.size > 0} fallback={null}>
									<Paragraph color={tokens.color_gray_dark}>
										{formatFileSize(file.size)}
									</Paragraph>
								</Show>
							</div>
						</div>
						<ButtonsContainer>
							<Show when={enableOpenFileButton} fallback={null}>
								<Button
									width="auto"
									variant="label"
									onClick={() => setSelectedFile(file)}
								>
									<OpenFile fontSize={25} />
								</Button>
							</Show>
							<Button
								width="auto"
								variant="label"
								onClick={() => handleDeleteFile(file.name)}
							>
								<FiTrash fontSize={25} color={tokens.color_primary} />
							</Button>
						</ButtonsContainer>
					</Content>
				))}
			</Item>
		);
	}

	return null;
};
